// H6 Text Scramble Animation with GSAP
(function() {
  // Wait for GSAP, ScrollTrigger, and ScrambleTextPlugin to be loaded
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || typeof ScrambleTextPlugin === 'undefined') {
    console.warn('GSAP, ScrollTrigger, or ScrambleTextPlugin not loaded');
    return;
  }

  // Register plugins
  gsap.registerPlugin(ScrollTrigger, ScrambleTextPlugin);

  // Select all h6 elements
  const h6Elements = document.querySelectorAll('h6');

  if (h6Elements.length === 0) {
    return;
  }

  // Apply scramble animation to each h6 element
  h6Elements.forEach((h6) => {
    // Store the original text
    const originalText = h6.textContent;
    
    // Create the scramble animation with ScrollTrigger
    gsap.from(h6, {
      scrollTrigger: {
        trigger: h6,
        start: 'top 80%', // Animation starts when h6 is 80% from the top of viewport
        end: 'top 60%',   // Animation ends when h6 is 60% from the top of viewport
        toggleActions: 'play none none none', // Only play once when entering
        // markers: true, // Uncomment for debugging
      },
      duration: 1,
      scrambleText: {
        text: originalText,
        chars: "!<>-_\\/[]{}—=+*^?#________",
        revealDelay: 0.5,
        speed: 0.3,
      }
    });
  });
})();
